import { Component, Injector, OnInit } from '@angular/core';
import { FormGenerico } from '../../generic/formgenerico/formgenerico';
import { ImportacaoFormModule } from './importacaoform.module';
import { ImportacaoStatus } from 'src/app/model/importacao/importacaoStatus';
import { ImportacaoStatusService } from 'src/app/services/importacao/importacao-status.service';

@Component({
  selector: 'app-form-functions',
  templateUrl: '../../generic/formgenerico/formgenerico.component.html',
  styleUrls: [ '../../generic/formgenerico/formgenerico.component.css']
})

export class FormImportacaoStatusComponent extends FormGenerico<ImportacaoStatus> implements OnInit {

  constructor(
    injectorObj: Injector,
    api: ImportacaoStatusService) 
  {
    super(injectorObj, api);
    this.obj = new ImportacaoStatus();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  dataExtraObj(res: any) {
  }

  protected onPropertyChange(propName: string, newValue: any): void {}
}
